import type { Locale } from "../../src/types.js"

export type AuthMessages = Record<string, Record<string, string>>

export const messages = {
  en: {
    signInCommon: {
      slogan: "The Leading\nMetals Information Provider",
      bySigning: "By Creating an account, you agree to SMM’s",
      privacyPolicy: "Privacy Policy",
      and: "and",
      TermsConditions: "Terms & Conditions",
      copyright: "Copyright",
      send: "Send",
      resend: "Resend",
      verifyViaSms: "Verify via SMS",
      verifyViaWhatsapp: "Verify via WhatsApp",
      requireCode: "Please enter the verification code",
      requireAccount: "Please enter email address or phone number",
      requireEmail: "Please enter email address",
      validEmail: "Please enter a valid email address",
      requirePhone: "Please enter phone number",
      requirePhoneCode: "Please select phone code",
      validPhone: "Please enter a valid phone number",
      alreadyAccount: "You already have an account",
      emailNotFound: "No account found with this email address",
      smmInformation: "SMM Information & Technology Co., Ltd. All rights reserved",
    },
    login: {
      title: "Welcome to SMM",
      emailAddress: "Email Address",
      emailAddress_error: "No account found with this email address",
      password: "Password",
      requirePassword: "Please enter password",
      remember: "Remember me",
      forgot: "Forgot password",
      signIn: "Sign in",
      signIn_toast: "The email or password you entered is incorrect",
      signIn_toast_with_tries_left: "The email or password is incorrect, {count} tries left before lock.",
      signIn_locked_toast: 'Account locked for 1 hour. Please wait or click <link>"Forgot password"</link> to reset.',
      simplePasswordMessage:
        'Your current password is too simple. Click <link>"Forgot password"</link> to change it for safety.',
      or: "Or",
      continue: "Continue with Google",
      noAccount: "Don't have an account",
      signUp: "Sign up",
    },
    register: {
      title: "Create Account",
      password: "Password",
      requirePassword: "Please enter password",
      emailCode: "Verification Code",
      emailCode_error: "Email code is incorrect",
      signIn: "Sign in",
      continue: "Continue",
      hasAccount: "Have an account?",
      registerSuccess: "Sign-up successful",
      phoneVerificationCode: "Phone Verification Code",
    },
    forgot: {
      title: "Forgot Password",
      emailAddress: "Email Address",
      emailCode: "Verification Code",
      emailCode_error: "Email code is incorrect",
      newPassword: "New Password",
      requirePassword: "Please enter new password",
      newPassword_error2: "Passwords do not match.",
      confirmPassword: "Confirm New Password",
      requireConfirmPassword: "Please confirm new password",
      passwordsNotMatch: "Passwords do not match",
      simplePasswordTip: "8-20 characters, no spaces, with at least 3 of: uppercase, lowercase, numbers, symbols.",
      reset: "Reset",
      resetSuccess: "Password reset successfully!",
      changePassword: "Change Password",
      oldPassword: "Old Password",
    },
    passwordRules: {
      length: "8-20 characters",
      length_error: "Your password needs to be 8-20 characters long.",
      composition: "At least 3 of: uppercase, lowercase, numbers, symbols. No spaces.",
    },
    accountInput: {
      accountLabel: "Email address or phone number",
      accountPlaceholder: "Email or phone",
      emailPlaceholder: "Email Address",
      phonePlaceholder: "Phone Number",
      phoneCodePlaceholder: "Code",
      loadFailed: "Unable to load phone codes",
      retry: "Retry",
      noResults: "No matching phone codes",
    },
  },
  es: {
    signInCommon: {
      slogan: "El proveedor líder de información sobre metales",
      bySigning: "Al crear una cuenta, usted acepta los",
      privacyPolicy: "Política de privacidad",
      and: "y",
      TermsConditions: "Términos y Condiciones",
      copyright: "Derechos de Autor",
      send: "Enviar",
      resend: "Reenviar",
      verifyViaSms: "Verificar por SMS",
      verifyViaWhatsapp: "Verificar por WhatsApp",
      requireCode: "Por favor, ingrese el código de verificación",
      requireAccount: "Por favor, ingrese la dirección de correo electrónico o el número de teléfono",
      requireEmail: "Por favor, ingrese la dirección de correo electrónico",
      validEmail: "Por favor, ingrese una dirección de correo electrónico válida",
      requirePhone: "Introduce el número de teléfono",
      requirePhoneCode: "Selecciona el código telefónico",
      validPhone: "Introduce un número de teléfono válido",
      alreadyAccount: "Ya tienes una cuenta",
      emailNotFound: "No se encontró ninguna cuenta con esta dirección de correo electrónico",
      smmInformation: "SMM Información y Tecnología, S.L. Derechos reservados",
    },
    login: {
      title: "Bienvenido a SMM",
      emailAddress: "Dirección de correo electrónico",
      emailAddress_error: "No se encontró ninguna cuenta con esta dirección de correo electrónico",
      password: "Contraseña",
      requirePassword: "Por favor, ingrese la contraseña",
      remember: "Recordarme",
      forgot: "¿Olvidaste tu contraseña",
      signIn: "Iniciar sesión",
      signIn_toast: "El correo electrónico o la contraseña que ingresaste es incorrecto",
      signIn_toast_with_tries_left:
        "El correo electrónico o la contraseña son incorrectos. Quedan {count} intentos antes del bloqueo.",
      signIn_locked_toast:
        'La cuenta está bloqueada durante 1 hora. Espera o haz clic en <link>"¿Olvidaste tu contraseña"</link> para restablecerla.',
      simplePasswordMessage:
        'Tu contraseña actual es demasiado simple. Haz clic en <link>"¿Olvidaste tu contraseña?"</link> para cambiarla por seguridad.',
      or: "O",
      continue: "Continuar con Google",
      noAccount: "¿No tienes una cuenta?",
      signUp: "Registrarse",
    },
    register: {
      title: "Crear Cuenta",
      password: "Contraseña",
      requirePassword: "Por favor, ingrese la contraseña",
      emailCode: "Código de correo electrónico",
      emailCode_error: "El código de correo electrónico es incorrecto",
      signIn: "Iniciar sesión",
      continue: "Continuar",
      hasAccount: "¿Ya tienes una cuenta?",
      registerSuccess: "Registro exitoso",
      phoneVerificationCode: "Código de verificación telefónica",
    },
    forgot: {
      title: "Olvidé mi contraseña",
      emailAddress: "Dirección de correo electrónico",
      emailCode: "Código de correo electrónico",
      emailCode_error: "El código de correo electrónico es incorrecto",
      newPassword: "Nueva Contraseña",
      requirePassword: "Por favor, ingrese la contraseña",
      newPassword_error2: "Las contraseñas no coinciden. ",
      confirmPassword: "Confirmar nueva contraseña",
      requireConfirmPassword: "Por favor, confirme la nueva contraseña",
      passwordsNotMatch: "Las contraseñas no coinciden",
      simplePasswordTip:
        "8-20 caracteres, sin espacios, con al menos 3 de: mayúsculas, minúsculas, números y símbolos.",
      reset: "Restablecer",
      resetSuccess: "¡Restablecimiento de contraseña exitoso!",
      changePassword: "Cambiar contraseña",
      oldPassword: "Contraseña Antigua",
    },
    passwordRules: {
      length: "8-20 caracteres",
      length_error: "Tu contraseña debe tener entre 8 y 20 caracteres.",
      composition: "Al menos 3 de: mayúsculas, minúsculas, números y símbolos. Sin espacios.",
    },
    accountInput: {
      accountLabel: "Correo electrónico o número de teléfono",
      accountPlaceholder: "Correo electrónico o teléfono",
      emailPlaceholder: "Dirección de correo electrónico",
      phonePlaceholder: "Número de teléfono",
      phoneCodePlaceholder: "Código",
      loadFailed: "No se pudieron cargar los códigos telefónicos",
      retry: "Reintentar",
      noResults: "No hay códigos telefónicos coincidentes",
    },
  },
  fr: {
    signInCommon: {
      slogan: "Le principal fournisseur d'informations sur les métaux",
      bySigning: "En créant un compte, vous acceptez les conditions de SMM",
      privacyPolicy: "Politique de confidentialité",
      and: "et",
      TermsConditions: "Conditions générales",
      copyright: "Droits d'auteur",
      send: "Envoyer",
      resend: "Renvoyer",
      verifyViaSms: "Vérifier par SMS",
      verifyViaWhatsapp: "Vérifier via WhatsApp",
      requireCode: "Veuillez saisir le code de vérification",
      requireAccount: "Veuillez saisir votre adresse e-mail ou votre numéro de téléphone",
      requireEmail: "Veuillez saisir votre adresse e-mail",
      validEmail: "Veuillez saisir une adresse e-mail valide",
      requirePhone: "Veuillez saisir le numéro de téléphone",
      requirePhoneCode: "Veuillez sélectionner l’indicatif téléphonique",
      validPhone: "Veuillez saisir un numéro de téléphone valide",
      alreadyAccount: "Vous avez déjà un compte",
      emailNotFound: "Aucun compte trouvé avec cette adresse e-mail",
      smmInformation: "SMM Information & Technology Co., Ltd. Tous droits réservés",
    },
    login: {
      title: "Bienvenue sur SMM",
      emailAddress: "Adresse e-mail",
      emailAddress_error: "Aucun compte trouvé avec cette adresse e-mail",
      password: "Mot de passe",
      requirePassword: "Veuillez saisir le mot de passe",
      remember: "Se souvenir de moi",
      forgot: "Mot de passe oublié",
      signIn: "Se connecter",
      signIn_toast: "L'adresse e-mail ou le mot de passe saisi est incorrect",
      signIn_toast_with_tries_left:
        "L'adresse e-mail ou le mot de passe est incorrect, il vous reste {count} tentatives avant le verrouillage.",
      signIn_locked_toast:
        'Compte verrouillé pendant 1 heure. Veuillez patienter ou cliquer sur <link>"Mot de passe oublié"</link> pour le réinitialiser.',
      simplePasswordMessage:
        'Votre mot de passe actuel est trop simple. Cliquez sur <link>"Mot de passe oublié"</link> pour le modifier par sécurité.',
      or: "Ou",
      continue: "Continuer avec Google",
      noAccount: "Vous n'avez pas de compte",
      signUp: "S'inscrire",
    },
    register: {
      title: "Créer un Compte",
      password: "Mot de passe",
      requirePassword: "Veuillez saisir le mot de passe",
      emailCode: "Code e-mail",
      emailCode_error: "Le code e-mail est incorrect",
      signIn: "Se connecter",
      continue: "Continuer",
      hasAccount: "Vous avez un compte ?",
      registerSuccess: "Inscription réussie",
      phoneVerificationCode: "Code de vérification téléphonique",
    },
    forgot: {
      title: "Mot de passe oublié",
      emailAddress: "Adresse e-mail",
      emailCode: "Code e-mail",
      emailCode_error: "Le code e-mail est incorrect",
      newPassword: "Nouveau mot de passe",
      requirePassword: "Veuillez saisir un nouveau mot de passe",
      newPassword_error2: "Les mots de passe ne correspondent pas. ",
      confirmPassword: "Confirmer le nouveau mot de passe",
      requireConfirmPassword: "Veuillez confirmer le nouveau mot de passe",
      passwordsNotMatch: "Les mots de passe ne correspondent pas",
      simplePasswordTip:
        "8-20 caractères, sans espaces, avec au moins 3 parmi : majuscules, minuscules, chiffres, symboles.",
      reset: "Réinitialiser",
      resetSuccess: "Réinitialisation du mot de passe réussie !",
      changePassword: "Changer le mot de passe",
      oldPassword: "Ancien Mot de Passe",
    },
    passwordRules: {
      length: "8-20 caractères",
      length_error: "Votre mot de passe doit contenir entre 8 et 20 caractères.",
      composition: "Au moins 3 parmi : majuscules, minuscules, chiffres, symboles. Sans espaces.",
    },
    accountInput: {
      accountLabel: "Adresse e-mail ou numéro de téléphone",
      accountPlaceholder: "E-mail ou téléphone",
      emailPlaceholder: "Adresse e-mail",
      phonePlaceholder: "Numéro de téléphone",
      phoneCodePlaceholder: "Code",
      loadFailed: "Impossible de charger les indicatifs",
      retry: "Réessayer",
      noResults: "Aucun indicatif correspondant",
    },
  },
  id: {
    signInCommon: {
      slogan: "Penyedia Informasi Logam Terkemuka",
      bySigning: "Dengan Membuat akun, Anda menyetujui SMM",
      privacyPolicy: "Kebijakan Privasi",
      and: "dan",
      TermsConditions: "Syarat & Ketentuan",
      copyright: "Hak Cipta",
      send: "Kirim",
      resend: "Kirim Ulang",
      verifyViaSms: "Verifikasi melalui SMS",
      verifyViaWhatsapp: "Verifikasi melalui WhatsApp",
      requireCode: "Masukkan kode verifikasi",
      requireAccount: "Masukkan alamat email atau nomor telepon",
      requireEmail: "Masukkan alamat email",
      validEmail: "Masukkan alamat email yang valid",
      requirePhone: "Silakan masukkan nomor telepon",
      requirePhoneCode: "Silakan pilih kode telepon",
      validPhone: "Silakan masukkan nomor telepon yang valid",
      alreadyAccount: "Anda sudah memiliki akun",
      emailNotFound: "Tidak ada akun yang ditemukan dengan alamat email ini",
      smmInformation: "PT. Informasi & Teknologi SMMSeluruh hak cipta dilindungi undang-undang",
    },
    login: {
      title: "Selamat datang di SMM",
      emailAddress: "Alamat Email",
      emailAddress_error: "Tidak ada akun yang ditemukan dengan alamat email ini",
      password: "Kata Sandi",
      requirePassword: "Masukkan kata sandi",
      remember: "Ingat saya",
      forgot: "Lupa kata sandi",
      signIn: "Masuk",
      signIn_toast: "Email atau kata sandi yang Anda masukkan salah",
      signIn_toast_with_tries_left: "Email atau kata sandi salah, tersisa {count} percobaan sebelum akun dikunci.",
      signIn_locked_toast:
        'Akun dikunci selama 1 jam. Silakan tunggu atau klik <link>"Lupa kata sandi"</link> untuk mereset.',
      simplePasswordMessage:
        'Kata sandi Anda saat ini terlalu sederhana. Klik <link>"Lupa kata sandi"</link> untuk mengubahnya demi keamanan.',
      or: "Atau",
      continue: "Lanjutkan dengan Google",
      noAccount: "Belum punya akun",
      signUp: "Daftar",
    },
    register: {
      title: "Buat Akun",
      password: "Kata Sandi",
      requirePassword: "Masukkan kata sandi",
      emailCode: "Kode Email",
      emailCode_error: "Kode email salah",
      signIn: "Masuk",
      continue: "Lanjutkan",
      hasAccount: "Sudah punya akun?",
      registerSuccess: "Pendaftaran berhasil",
      phoneVerificationCode: "Kode Verifikasi Telepon",
    },
    forgot: {
      title: "Lupa Kata Sandi",
      emailAddress: "Alamat Email",
      emailCode: "Kode Email",
      emailCode_error: "Kode email salah",
      newPassword: "Kata Sandi Baru",
      requirePassword: "Masukkan kata sandi baru",
      newPassword_error2: "Kata sandi tidak cocok. ",
      confirmPassword: "Konfirmasi Kata Sandi Baru",
      requireConfirmPassword: "Harap konfirmasi kata sandi baru",
      passwordsNotMatch: "Kata sandi tidak cocok",
      simplePasswordTip:
        "8-20 karakter, tanpa spasi, dengan setidaknya 3 dari: huruf besar, huruf kecil, angka, simbol.",
      reset: "Atur Ulang",
      resetSuccess: "Setel ulang kata sandi berhasil!",
      changePassword: "Ubah Kata Sandi",
      oldPassword: "Kata Sandi Lama",
    },
    passwordRules: {
      length: "8-20 karakter",
      length_error: "Kata sandi Anda harus terdiri dari 8-20 karakter.",
      composition: "Setidaknya 3 dari: huruf besar, huruf kecil, angka, simbol. Tanpa spasi.",
    },
    accountInput: {
      accountLabel: "Alamat email atau nomor telepon",
      accountPlaceholder: "Email atau telepon",
      emailPlaceholder: "Alamat Email",
      phonePlaceholder: "Nomor Telepon",
      phoneCodePlaceholder: "Kode",
      loadFailed: "Tidak dapat memuat kode telepon",
      retry: "Coba lagi",
      noResults: "Tidak ada kode telepon yang cocok",
    },
  },
  ko: {
    signInCommon: {
      slogan: "선도적인 금속 정보 제공업체",
      bySigning: "계정을 생성하면 SMM의",
      privacyPolicy: "개인정보 처리방침",
      and: "및",
      TermsConditions: "이용약관",
      copyright: "저작권",
      send: "보내기",
      resend: "재전송",
      verifyViaSms: "SMS로 인증",
      verifyViaWhatsapp: "WhatsApp으로 인증",
      requireCode: "인증 코드를 입력하세요",
      requireAccount: "이메일 주소 또는 전화번호를 입력하세요",
      requireEmail: "이메일 주소를 입력하세요",
      validEmail: "유효한 이메일 주소를 입력하세요",
      requirePhone: "전화번호를 입력하세요",
      requirePhoneCode: "국가 번호를 선택하세요",
      validPhone: "유효한 전화번호를 입력하세요",
      alreadyAccount: "이미 계정이 있습니다",
      emailNotFound: "해당 이메일 주소로 등록된 계정을 찾을 수 없습니다",
      smmInformation: "SMM Information & Technology Co., Ltd. All rights reserved",
    },
    login: {
      title: "SMM에 오신 것을 환영합니다",
      emailAddress: "이메일 주소",
      emailAddress_error: "해당 이메일 주소로 등록된 계정을 찾을 수 없습니다",
      password: "비밀번호",
      requirePassword: "비밀번호를 입력하세요",
      remember: "로그인 정보 기억",
      forgot: "비밀번호 찾기",
      signIn: "로그인",
      signIn_toast: "입력하신 이메일 또는 비밀번호가 올바르지 않습니다",
      signIn_toast_with_tries_left: "이메일 또는 비밀번호가 올바르지 않습니다. 잠금 전 {count}회 시도 남았습니다.",
      signIn_locked_toast:
        '계정이 1시간 동안 잠겼습니다. 잠시 기다리시거나 <link>"비밀번호 찾기"</link>를 클릭하여 재설정하세요.',
      simplePasswordMessage:
        '현재 비밀번호가 너무 단순합니다. 안전을 위해 <link>"비밀번호 찾기"</link>를 클릭하여 변경하세요. ',
      or: "또는",
      continue: "Google로 계속하기",
      noAccount: "계정이 없으신가요",
      signUp: "회원가입",
    },
    register: {
      title: "계정 만들기",
      password: "비밀번호",
      requirePassword: "비밀번호를 입력하세요",
      emailCode: "이메일 코드",
      emailCode_error: "이메일 인증 코드가 올바르지 않습니다",
      signIn: "로그인",
      continue: "계속",
      hasAccount: "계정이 있으신가요?",
      registerSuccess: "가입 완료",
      phoneVerificationCode: "휴대폰 인증 코드",
    },
    forgot: {
      title: "비밀번호 찾기",
      emailAddress: "이메일 주소",
      emailCode: "이메일 코드",
      emailCode_error: "이메일 인증 코드가 올바르지 않습니다",
      newPassword: "새 비밀번호",
      requirePassword: "새 비밀번호를 입력하세요",
      newPassword_error2: "비밀번호가 일치하지 않습니다. ",
      confirmPassword: "새 비밀번호 확인",
      requireConfirmPassword: "새 비밀번호를 확인해 주세요",
      passwordsNotMatch: "비밀번호가 일치하지 않습니다",
      simplePasswordTip: "8~20자, 공백 없이, 대문자·소문자·숫자·기호 중 3가지 이상 포함. ",
      reset: "재설정",
      resetSuccess: "비밀번호가 성공적으로 재설정되었습니다!",
      changePassword: "비밀번호 변경",
      oldPassword: "기존 비밀번호",
    },
    passwordRules: {
      length: "8~20자",
      length_error: "비밀번호는 8~20자여야 합니다. ",
      composition: "대문자, 소문자, 숫자, 기호 중 최소 3가지 포함. 공백 없음.",
    },
    accountInput: {
      accountLabel: "이메일 주소 또는 전화번호",
      accountPlaceholder: "이메일 또는 전화번호",
      emailPlaceholder: "이메일 주소",
      phonePlaceholder: "전화번호",
      phoneCodePlaceholder: "코드",
      loadFailed: "국가 번호를 불러올 수 없습니다",
      retry: "다시 시도",
      noResults: "일치하는 국가 번호가 없습니다",
    },
  },
  pt: {
    signInCommon: {
      slogan: "O principal provedor de informações sobre metais",
      bySigning: "Ao criar uma conta, você concorda com os",
      privacyPolicy: "Política de Privacidade",
      and: "e",
      TermsConditions: "Termos e Condições",
      copyright: "Direitos Autorais",
      send: "Enviar",
      resend: "Reenviar",
      verifyViaSms: "Verificar por SMS",
      verifyViaWhatsapp: "Verificar pelo WhatsApp",
      requireCode: "Por favor, insira o código de verificação",
      requireAccount: "Por favor, insira o endereço de e-mail ou número de telefone",
      requireEmail: "Por favor, insira o endereço de e-mail",
      validEmail: "Por favor, insira um endereço de e-mail válido",
      requirePhone: "Insira o número de telefone",
      requirePhoneCode: "Selecione o código telefônico",
      validPhone: "Insira um número de telefone válido",
      alreadyAccount: "Você já tem uma conta",
      emailNotFound: "Nenhuma conta encontrada com este endereço de e-mail",
      smmInformation: "SMM Informação & Tecnologia Ltda. Todos os direitos reservados",
    },
    login: {
      title: "Bem-vindo ao SMM",
      emailAddress: "Endereço de E-mail",
      emailAddress_error: "Nenhuma conta encontrada com este endereço de e-mail",
      password: "Senha",
      requirePassword: "Por favor, insira a senha",
      remember: "Lembrar-me",
      forgot: "Esqueceu a palavra-passe",
      signIn: "Entrar",
      signIn_toast: "O e-mail ou a palavra-passe que introduziu estão incorretos",
      signIn_toast_with_tries_left:
        "O e-mail ou a palavra-passe estão incorretos, restam {count} tentativas antes do bloqueio.",
      signIn_locked_toast:
        'Conta bloqueada durante 1 hora. Aguarde ou clique em <link>"Esqueceu a palavra-passe"</link> para redefinir.',
      simplePasswordMessage:
        'A sua senha atual é demasiado simples. Clique em <link>"Esqueceu a senha"</link> para alterá-la por segurança.',
      or: "Ou",
      continue: "Continuar com o Google",
      noAccount: "Não tem uma conta",
      signUp: "Registar",
    },
    register: {
      title: "Criar Conta",
      password: "Senha",
      requirePassword: "Por favor, insira a senha",
      emailCode: "Código por E-mail",
      emailCode_error: "Código de e-mail incorreto",
      signIn: "Entrar",
      continue: "Continuar",
      hasAccount: "Já tem uma conta?",
      registerSuccess: "Cadastro realizado com sucesso",
      phoneVerificationCode: "Código de verificação por telefone",
    },
    forgot: {
      title: "Esqueceu a Senha",
      emailAddress: "Endereço de E-mail",
      emailCode: "Código por E-mail",
      emailCode_error: "Código de e-mail incorreto",
      newPassword: "Nova Palavra-passe",
      requirePassword: "Por favor, insira a nova senha",
      newPassword_error2: "As senhas não coincidem. ",
      confirmPassword: "Confirmar Nova Senha",
      requireConfirmPassword: "Por favor, confirme a nova senha",
      passwordsNotMatch: "As palavras-passe não coincidem",
      simplePasswordTip:
        "8-20 caracteres, sem espaços, com pelo menos 3 de: maiúsculas, minúsculas, números, símbolos.",
      reset: "Redefinir",
      resetSuccess: "Redefinição de senha bem-sucedida!",
      changePassword: "Alterar Senha",
      oldPassword: "Senha Antiga",
    },
    passwordRules: {
      length: "8-20 caracteres",
      length_error: "Sua senha deve ter entre 8 e 20 caracteres.",
      composition: "Pelo menos 3 destes: maiúsculas, minúsculas, números e símbolos. Sem espaços.",
    },
    accountInput: {
      accountLabel: "Endereço de e-mail ou número de telefone",
      accountPlaceholder: "E-mail ou telefone",
      emailPlaceholder: "Endereço de E-mail",
      phonePlaceholder: "Número de telefone",
      phoneCodePlaceholder: "Código",
      loadFailed: "Não foi possível carregar os códigos telefônicos",
      retry: "Tentar novamente",
      noResults: "Nenhum código telefônico correspondente",
    },
  },
  ru: {
    signInCommon: {
      slogan: "Ведущий поставщик информации о металлах",
      bySigning: "Создавая аккаунт, вы соглашаетесь с условиями SMM",
      privacyPolicy: "Политика конфиденциальности",
      and: "и",
      TermsConditions: "Условия и положения",
      copyright: "Авторское право",
      send: "Отправить",
      resend: "Повторная отправка",
      verifyViaSms: "Подтвердить по SMS",
      verifyViaWhatsapp: "Подтвердить через WhatsApp",
      requireCode: "Введите код подтверждения",
      requireAccount: "Пожалуйста, введите адрес электронной почты или номер телефона",
      requireEmail: "Пожалуйста, введите адрес электронной почты",
      validEmail: "Пожалуйста, введите действительный адрес электронной почты",
      requirePhone: "Введите номер телефона",
      requirePhoneCode: "Выберите телефонный код",
      validPhone: "Введите корректный номер телефона",
      alreadyAccount: "У вас уже есть аккаунт",
      emailNotFound: "Аккаунт с таким адресом электронной почты не найден",
      smmInformation: "Информационные и технологические системы ОООВсе права защищены",
    },
    login: {
      title: "Добро пожаловать в SMM",
      emailAddress: "Адрес электронной почты",
      emailAddress_error: "Аккаунт с таким адресом электронной почты не найден",
      password: "Пароль",
      requirePassword: "Введите пароль",
      remember: "Запомнить меня",
      forgot: "Забыли пароль",
      signIn: "Войти",
      signIn_toast: "Введённый email или пароль неверны",
      signIn_toast_with_tries_left: "Email или пароль неверны, осталось {count} попыток до блокировки.",
      signIn_locked_toast:
        'Аккаунт заблокирован на 1 час. Подождите или нажмите <link>"Забыли пароль"</link>, чтобы сбросить пароль.',
      simplePasswordMessage:
        'Ваш текущий пароль слишком простой. Нажмите <link>"Забыли пароль"</link>, чтобы изменить его для безопасности.',
      or: "Или",
      continue: "Продолжить через Google",
      noAccount: "Нет аккаунта",
      signUp: "Зарегистрироваться",
    },
    register: {
      title: "Создать аккаунт",
      password: "Пароль",
      requirePassword: "Введите пароль",
      emailCode: "Код по электронной почте",
      emailCode_error: "Неверный код из электронной почты",
      signIn: "Войти",
      continue: "Продолжить",
      hasAccount: "Есть аккаунт?",
      registerSuccess: "Регистрация успешна",
      phoneVerificationCode: "Код подтверждения телефона",
    },
    forgot: {
      title: "Забыли пароль",
      emailAddress: "Адрес электронной почты",
      emailCode: "Код по электронной почте",
      emailCode_error: "Неверный код из электронной почты",
      newPassword: "Новый пароль",
      requirePassword: "Введите новый пароль",
      newPassword_error2: "Пароли не совпадают. ",
      confirmPassword: "Подтвердите новый пароль",
      requireConfirmPassword: "Пожалуйста, подтвердите новый пароль",
      passwordsNotMatch: "Пароли не совпадают",
      simplePasswordTip:
        "8-20 символов, без пробелов, как минимум 3 типа из: заглавные буквы, строчные буквы, цифры, символы.",
      reset: "Сброс",
      resetSuccess: "Пароль успешно сброшен！",
      changePassword: "Изменить пароль",
      oldPassword: "Старый пароль",
    },
    passwordRules: {
      length: "8-20 символов",
      length_error: "Ваш пароль должен содержать от 8 до 20 символов.",
      composition: "Как минимум 3 из: заглавные буквы, строчные буквы, цифры, символы. Без пробелов.",
    },
    accountInput: {
      accountLabel: "Адрес электронной почты или номер телефона",
      accountPlaceholder: "Электронная почта или телефон",
      emailPlaceholder: "Адрес электронной почты",
      phonePlaceholder: "Номер телефона",
      phoneCodePlaceholder: "Код",
      loadFailed: "Не удалось загрузить телефонные коды",
      retry: "Повторить",
      noResults: "Подходящие телефонные коды не найдены",
    },
  },
  th: {
    signInCommon: {
      slogan: "ผู้นำผู้ให้ข้อมูลด้านโลหะ",
      bySigning: "โดยการสร้างบัญชี คุณยอมรับตาม",
      privacyPolicy: "นโยบายความเป็นส่วนตัว",
      and: "และ",
      TermsConditions: "ข้อกำหนดและเงื่อนไข",
      copyright: "ลิขสิทธิ์",
      send: "ส่ง",
      resend: "ส่งซ้ำ",
      verifyViaSms: "ยืนยันผ่าน SMS",
      verifyViaWhatsapp: "ยืนยันผ่าน WhatsApp",
      requireCode: "กรุณากรอกรหัสยืนยัน",
      requireAccount: "กรุณากรอกที่อยู่อีเมลหรือหมายเลขโทรศัพท์",
      requireEmail: "กรุณากรอกที่อยู่อีเมล",
      validEmail: "กรุณากรอกอีเมลให้ถูกต้อง",
      requirePhone: "กรุณากรอกหมายเลขโทรศัพท์",
      requirePhoneCode: "กรุณาเลือกรหัสโทรศัพท์",
      validPhone: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
      alreadyAccount: "คุณมีบัญชีอยู่แล้ว",
      emailNotFound: "ไม่พบบัญชีที่ใช้อีเมลนี้",
      smmInformation: "บริษัท เอสเอ็มเอ็ม อินฟอร์เมชั่น แอนด์ เทคโนโลยี จำกัดAll rights reserved",
    },
    login: {
      title: "ยินดีต้อนรับสู่ SMM",
      emailAddress: "อีเมล",
      emailAddress_error: "ไม่พบบัญชีที่ใช้อีเมลนี้",
      password: "รหัสผ่าน",
      requirePassword: "กรุณาใส่รหัสผ่าน",
      remember: "จำฉันไว้",
      forgot: "ลืมรหัสผ่าน",
      signIn: "เข้าสู่ระบบ",
      signIn_toast: "อีเมลหรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง",
      signIn_toast_with_tries_left: "อีเมลหรือรหัสผ่านไม่ถูกต้อง เหลืออีก {count} ครั้งก่อนบัญชีถูกล็อก",
      signIn_locked_toast: 'บัญชีถูกล็อกเป็นเวลา 1 ชั่วโมง โปรดรอหรือคลิก <link>"ลืมรหัสผ่าน"</link> เพื่อรีเซ็ต',
      simplePasswordMessage:
        'รหัสผ่านปัจจุบันของคุณง่ายเกินไป คลิก <link>"ลืมรหัสผ่าน"</link> เพื่อเปลี่ยนเพื่อความปลอดภัย',
      or: "หรือ",
      continue: "ดำเนินการต่อด้วย Google",
      noAccount: "ยังไม่มีบัญชี",
      signUp: "สมัครสมาชิก",
    },
    register: {
      title: "สร้างบัญชี",
      password: "รหัสผ่าน",
      requirePassword: "กรุณาใส่รหัสผ่าน",
      emailCode: "รหัสอีเมล",
      emailCode_error: "รหัสอีเมลไม่ถูกต้อง",
      signIn: "เข้าสู่ระบบ",
      continue: "ดำเนินการต่อ",
      hasAccount: "มีบัญชีอยู่แล้ว?",
      registerSuccess: "สมัครสมาชิกสำเร็จ",
      phoneVerificationCode: "รหัสยืนยันทางโทรศัพท์",
    },
    forgot: {
      title: "ลืมรหัสผ่าน",
      emailAddress: "อีเมลแอดเดรส",
      emailCode: "รหัสอีเมล",
      emailCode_error: "รหัสอีเมลไม่ถูกต้อง",
      newPassword: "รหัสผ่านใหม่",
      requirePassword: "กรุณาใส่รหัสผ่านใหม่",
      newPassword_error2: "รหัสผ่านไม่ตรงกัน",
      confirmPassword: "ยืนยันรหัสผ่านใหม่",
      requireConfirmPassword: "กรุณายืนยันรหัสผ่านใหม่",
      passwordsNotMatch: "รหัสผ่านไม่ตรงกัน",
      simplePasswordTip:
        "8-20 ตัวอักษร, ห้ามเว้นวรรค, และต้องมีอย่างน้อย 3 ประเภทจาก: ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข สัญลักษณ์",
      reset: "รีเซ็ต",
      resetSuccess: "รีเซ็ตรหัสผ่านสำเร็จ",
      changePassword: "เปลี่ยนรหัสผ่าน",
      oldPassword: "รหัสผ่านเก่า",
    },
    passwordRules: {
      length: "8-20 ตัวอักษร",
      length_error: "รหัสผ่านของคุณต้องมีความยาว 8-20 ตัวอักษร",
      composition: "ต้องมีอย่างน้อย 3 อย่างจาก: ตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก ตัวเลข สัญลักษณ์ และห้ามมีช่องว่าง",
    },
    accountInput: {
      accountLabel: "อีเมลหรือหมายเลขโทรศัพท์",
      accountPlaceholder: "อีเมลหรือโทรศัพท์",
      emailPlaceholder: "ที่อยู่อีเมล",
      phonePlaceholder: "หมายเลขโทรศัพท์",
      phoneCodePlaceholder: "รหัส",
      loadFailed: "ไม่สามารถโหลดรหัสโทรศัพท์ได้",
      retry: "ลองอีกครั้ง",
      noResults: "ไม่พบรหัสโทรศัพท์ที่ตรงกัน",
    },
  },
  vn: {
    signInCommon: {
      slogan: "Nhà cung cấp thông tin kim loại hàng đầu",
      bySigning: "Bằng cách Tạo tài khoản, bạn đồng  ý với Điều khoản của SMM",
      privacyPolicy: "Chính sách Bảo mật",
      and: "và",
      TermsConditions: "Điều khoản & Điều kiện",
      copyright: "Bản quyền",
      send: "Gửi",
      resend: "Gửi lại",
      verifyViaSms: "Xác minh qua SMS",
      verifyViaWhatsapp: "Xác minh qua WhatsApp",
      requireCode: "Vui lòng nhập mã xác minh",
      requireAccount: "Vui lòng nhập địa chỉ email hoặc số điện thoại",
      requireEmail: "Vui lòng nhập địa chỉ email",
      validEmail: "Vui lòng nhập địa chỉ email hợp lệ",
      requirePhone: "Vui lòng nhập số điện thoại",
      requirePhoneCode: "Vui lòng chọn mã điện thoại",
      validPhone: "Vui lòng nhập số điện thoại hợp lệ",
      alreadyAccount: "Bạn đã có tài khoản",
      emailNotFound: "Không tìm thấy tài khoản nào với địa chỉ email này",
      smmInformation: "Công ty TNHH Công nghệ & Thông tin SMMTất cả các quyền được bảo lưu",
    },
    login: {
      title: "Chào mừng đến với SMM",
      emailAddress: "Địa chỉ Email",
      emailAddress_error: "Không tìm thấy tài khoản nào với địa chỉ email này",
      password: "Mật khẩu",
      requirePassword: "Vui lòng nhập mật khẩu",
      remember: "Ghi nhớ tôi",
      forgot: "Quên mật khẩu",
      signIn: "Đăng nhập",
      signIn_toast: "Email hoặc mật khẩu bạn nhập không chính xác",
      signIn_toast_with_tries_left: "Email hoặc mật khẩu không chính xác, còn {count} lần thử trước khi bị khóa.",
      signIn_locked_toast:
        'Tài khoản bị khóa trong 1 giờ. Vui lòng chờ hoặc nhấp vào <link>"Quên mật khẩu"</link> để đặt lại.',
      simplePasswordMessage:
        'Mật khẩu hiện tại của bạn quá đơn giản. Nhấp vào <link>"Quên mật khẩu"</link> để thay đổi nhằm đảm bảo an toàn.',
      or: "Hoặc",
      continue: "Tiếp tục với Google",
      noAccount: "Chưa có tài khoản",
      signUp: "Đăng ký",
    },
    register: {
      title: "Tạo Tài Khoản",
      password: "Mật khẩu",
      requirePassword: "Vui lòng nhập mật khẩu",
      emailCode: "Mã email",
      emailCode_error: "Mã email không chính xác",
      signIn: "Đăng nhập",
      continue: "Tiếp tục",
      hasAccount: "Đã có tài khoản?",
      registerSuccess: "Đăng ký thành công",
      phoneVerificationCode: "Mã xác minh điện thoại",
    },
    forgot: {
      title: "Quên Mật khẩu",
      emailAddress: "Địa chỉ Email",
      emailCode: "Mã email",
      emailCode_error: "Mã email không chính xác",
      newPassword: "Mật khẩu mới",
      requirePassword: "Vui lòng nhập mật khẩu mới",
      newPassword_error2: "Mật khẩu không khớp. ",
      confirmPassword: "Xác nhận mật khẩu mới",
      requireConfirmPassword: "Vui lòng xác nhận mật khẩu mới",
      passwordsNotMatch: "Mật khẩu không khớp",
      simplePasswordTip:
        "8-20 ký tự, không có khoảng trắng, với ít nhất 3 trong các loại: chữ hoa, chữ thường, số, ký tự đặc biệt.",
      reset: "Đặt lại",
      resetSuccess: "Đặt lại mật khẩu thành công!",
      changePassword: "Đổi mật khẩu",
      oldPassword: "Mật khẩu cũ",
    },
    passwordRules: {
      length: "8-20 ký tự",
      length_error: "Mật khẩu của bạn phải có từ 8 đến 20 ký tự.",
      composition: "Ít nhất 3 trong các loại sau: chữ hoa, chữ thường, số, ký tự đặc biệt. Không có khoảng trắng.",
    },
    accountInput: {
      accountLabel: "Địa chỉ email hoặc số điện thoại",
      accountPlaceholder: "Email hoặc điện thoại",
      emailPlaceholder: "Địa chỉ Email",
      phonePlaceholder: "Số điện thoại",
      phoneCodePlaceholder: "Mã",
      loadFailed: "Không thể tải mã điện thoại",
      retry: "Thử lại",
      noResults: "Không có mã điện thoại phù hợp",
    },
  },
} as Record<Locale, AuthMessages>
